import mainValues from "./main";
import ejariValues from "./ejari";
import mollakValues from "./mollalk";
import rvValues from "./rental_valuation";
import valuationValues from "./external_valuation";
import external_valuation from "./external_valuation";
import enocValues from "./enoc_mollak";
import mortgageQuotationValues from "./mortgage_quotation";
import { lvString, lvValues } from "@eres/core/dist/StringUtils";
import { LocaleValue } from "@eres/core/dist/LocaleValue";
import SvcStrings from "@my-dld/assets/strings/svc_description";
import SvcKeywords from "@my-dld/assets/strings/svc_keywords";
import rdcValues from "./rdc";
import greenListValues from "./green_list";
import addPropertyValues from "./add_property";
import privateSell from "./private_sell";
import ask_malik from "./ask_malik";
import { TabuProcedures, TabuRequestUtils } from "@10x/tabu-mobile-api";
import htValues from "./hand_take_over";
import finance_service from "./finance_service";
import { ProxyType } from "@eres/core";
import umbracoValues from "./umbraco_strings";

const values = {
	...mainValues,
	...ejariValues,
	...mollakValues,
	...rvValues,
	...valuationValues,
	...external_valuation,
	...mortgageQuotationValues,
	...rdcValues,
	...enocValues,
	...greenListValues,
	...addPropertyValues,
	...privateSell,
	...ask_malik,
	...htValues,
	...finance_service,
	...umbracoValues,
	...( window.AppInfo && window.AppInfo.AppStrings ? window.AppInfo.AppStrings : {} ),
};
TabuRequestUtils.addTabuServiceDescriptionToContainer( SvcStrings, TabuProcedures.OwnershipChange );
TabuRequestUtils.addTabuServiceDescriptionToContainer( SvcStrings, TabuProcedures.PropertyCutOff );
TabuRequestUtils.addTabuServiceDescriptionToContainer( SvcStrings, TabuProcedures.DelayedPropertyCutOff );
//TabuRequestUtils.addTabuServiceDescriptionToContainer(PropSvcStrings, TabuProcedures.OwnershipChange);
TabuRequestUtils.addTabuServiceDescriptionToContainer( SvcStrings, TabuProcedures.PropertyAnnex );
TabuRequestUtils.addTabuServiceDescriptionToContainer( SvcStrings, TabuProcedures.DelayedPropertyAnnex );

const Strings: { [ key: string ]: string } & ProxyType<typeof values, string> = lvString( values );
const LVStrings: { [ key: string ]: LocaleValue } & ProxyType<typeof values, LocaleValue> = lvValues( values );
const ServiceDescriptions = lvString( { ...SvcStrings } );
const LVServiceDescription = lvValues( { ...SvcStrings } );
const ServiceKeywords = lvString( { ...SvcKeywords } );

TabuRequestUtils.UpdateTabuSmartServiceInfo( TabuProcedures.BCSReClassification, LVStrings, LVServiceDescription );
TabuProcedures.ET.Name = LVStrings.download_certificate;
export { LVStrings, ServiceDescriptions, ServiceKeywords };
export default Strings;
checkMissingTr( mainValues );
if ( window.AppInfo && window.AppInfo.AppStrings ) checkMissingTr( window.AppInfo.AppStrings );

function checkMissingTr( target: any ) {
	const j = Object.keys( target );
	for ( const k of j ) {
		const v = target[ k ];
		const vk = Object.keys( v );
		if ( vk.length < 2 ) {
			console.log( "Missing translation", k );
		}
	}
}
